import {Injectable, Injector} from '@angular/core';
import {ApiResponse, BaseApiService} from '../../base-api.service';
import {WastageTypesModelService} from '../../../Models/Warehouse/Wastages/wastage-types-model.service';
import {WastagesModelService} from '../../../Models/Warehouse/Wastages/wastages-model.service';
import {WastageForm} from '../../../../Models/Warehouse/Wastages/wastage-store.model';

@Injectable({
  providedIn: 'root'
})
export class WastagesApiService extends BaseApiService {

  constructor(
    protected override injector: Injector,
    public modelTypes: WastageTypesModelService,
    public model: WastagesModelService,
  ) {
    super(injector);
  }


  /**
   * Obtener mermas
   *
   */
  getWastages(save: boolean = true): Promise<ApiResponse> {

    return new Promise((resolve, reject) => {

      return this.httpCall('getMermas', {}).subscribe({
        next: (response) => {
          if (save) {
            this.model.save(response.data);
          }

          resolve(response);
        },
        error: (err) => {
          reject(err)
        }
      });

    });

  }


  /**
   * Obtener tipo mermas
   *
   */
  getWastageTypes(save: boolean = true): Promise<ApiResponse> {

    return new Promise((resolve, reject) => {

      return this.httpCall('getTiposMermas', {}, 'get').subscribe({
        next: (response) => {
          if (save) {
            this.modelTypes.save(response.data);
          }

          resolve(response);
        },
        error: (err) => {
          reject(err)
        }
      });

    });

  }


  /**
   * Guardar merma
   *
   */
  saveWastage(form: WastageForm): Promise<ApiResponse> {

    return new Promise((resolve, reject) => {

      return this.httpCall('addMerma', form).subscribe({
        next: (response) => {
          resolve(response);
        },
        error: (err) => {
          reject(err)
        }
      });

    });

  }


  /**
   * Guardar imagen merma
   *
   */
  saveWastageImage(form: FormData): Promise<ApiResponse> {

    return new Promise((resolve, reject) => {

      return this.httpCall('postImagenMerma', form, 'post', true).subscribe({
        next: (response) => {
          resolve(response);
        },
        error: (err) => {
          reject(err)
        }
      });

    });

  }

}
